export default __webpack_public_path__ + "static/media/calendar-grey.f888fd6e.svg";